import { aICreatorUpdateOutlineAction } from 'src/reducers/ai-creator/action'

export const useDragAndDrop = (data, dispatch, setCreditCost) => {
  const onDragEnd = result => {
    if (!result.destination) return

    const { source, destination, type } = result
    const newData = [...data.response.outline.sections]

    if (type === 'SECTION') {
      const [movedSection] = newData.splice(source.index, 1)
      newData.splice(destination.index, 0, movedSection)
    } else if (type === 'MODULE') {
      const sourceSectionIndex = parseInt(source.droppableId.split('-')[1])
      const destinationSectionIndex = parseInt(
        destination.droppableId.split('-')[1],
      )

      const sourceSection = newData[sourceSectionIndex]
      const destinationSection = newData[destinationSectionIndex]

      const [movedModule] = sourceSection.modules.splice(source.index, 1)

      if (sourceSectionIndex === destinationSectionIndex) {
        sourceSection.modules.splice(destination.index, 0, movedModule)
      } else {
        destinationSection.modules.splice(destination.index, 0, movedModule)
      }
    }

    // Update data with new structure and trigger outline update
    dispatch(
      aICreatorUpdateOutlineAction(
        { outline: { ...data.response.outline, sections: newData } },
        data.response.outlineId,
        response => {
          setCreditCost(response.credit_cost)
        },
      ),
    )
  }

  return { onDragEnd }
}
